document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initColorSwatch();
  initAntesDespues();
  initResenasCarrusel();
  initGaleriaProducto();
  initSelectorVariantes();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initContador() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-mt-contador'));
      var suffix = el.getAttribute('data-mt-sufijo') || '';
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = target % 1 === 0 ? Math.round(target * eased) : (target * eased).toFixed(1);
        el.textContent = value + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      observer.unobserve(el);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initColorSwatch() {
  var grupos = document.querySelectorAll('[data-mt-color-grupo]');
  grupos.forEach(function (grupo) {
    var botones = grupo.querySelectorAll('[data-mt-color-btn]');
    var imagen = grupo.querySelector('[data-mt-color-imagen]');
    var nombre = grupo.querySelector('[data-mt-color-nombre]');
    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        botones.forEach(function (b) { b.classList.remove('mt-activo'); });
        btn.classList.add('mt-activo');
        if (imagen && btn.getAttribute('data-mt-color-imagen-src')) {
          imagen.src = btn.getAttribute('data-mt-color-imagen-src');
        }
        if (nombre) nombre.textContent = btn.getAttribute('data-mt-color-label') || '';
      });
    });
  });
}

function initAntesDespues() {
  var wraps = document.querySelectorAll('[data-mt-antes-despues]');
  wraps.forEach(function (wrap) {
    var handle = wrap.querySelector('[data-mt-handle]');
    var despuesCapa = wrap.querySelector('[data-mt-despues-capa]');
    if (!handle || !despuesCapa) return;
    var dragging = false;

    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      var pct = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1) * 100;
      despuesCapa.style.width = pct + '%';
      handle.style.left = pct + '%';
    }

    handle.addEventListener('pointerdown', function (e) {
      dragging = true;
      handle.setPointerCapture(e.pointerId);
    });
    handle.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPos(e.clientX);
    });
    handle.addEventListener('pointerup', function () { dragging = false; });
    wrap.addEventListener('click', function (e) {
      if (e.target === handle) return;
      setPos(e.clientX);
    });
  });
}

function initResenasCarrusel() {
  var pistas = document.querySelectorAll('[data-mt-resenas-pista]');
  pistas.forEach(function (pista) {
    var contenedor = pista.closest('[data-mt-resenas-wrap]');
    if (!contenedor) return;
    var prev = contenedor.querySelector('[data-mt-resenas-prev]');
    var next = contenedor.querySelector('[data-mt-resenas-next]');
    var paso = function () {
      var tarjeta = pista.querySelector('.mt-resena');
      return tarjeta ? tarjeta.getBoundingClientRect().width + 20 : 320;
    };
    if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
  });
}

function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-mt-full');
        if (!src) return;
        principal.src = src;
        minis.forEach(function (m) { m.classList.remove('mt-activo'); });
        mini.classList.add('mt-activo');
      });
    });
  });
}

function initSelectorVariantes() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selects = form.querySelectorAll('[data-mt-opcion]');
    var idInput = form.querySelector('[data-mt-variant-id]');
    var precioEl = form.querySelector('[data-mt-precio]');
    var precioTachado = form.querySelector('[data-mt-precio-tachado]');
    var botonComprar = form.querySelector('[data-mt-comprar]');

    function opcionesSeleccionadas() {
      var vals = [];
      selects.forEach(function (s) { vals.push(s.value); });
      return vals;
    }

    function actualizar() {
      var seleccion = opcionesSeleccionadas();
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;
      if (idInput) idInput.value = variante.id;
      if (precioEl) precioEl.textContent = variante.price_formatted;
      if (precioTachado) {
        if (variante.compare_at_price_formatted) {
          precioTachado.textContent = variante.compare_at_price_formatted;
          precioTachado.style.display = '';
        } else {
          precioTachado.style.display = 'none';
        }
      }
      if (botonComprar) {
        if (variante.available) {
          botonComprar.disabled = false;
          botonComprar.textContent = botonComprar.getAttribute('data-mt-texto-disponible');
        } else {
          botonComprar.disabled = true;
          botonComprar.textContent = botonComprar.getAttribute('data-mt-texto-agotado');
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}
